import { useEffect, useState } from "react";
import axios, { API } from "@/lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import LoadingScreen from "@/components/shared/LoadingScreen";

export default function FAQPage() {
  const [faqs, setFaqs] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/faqs`).then(({ data }) => setFaqs(data)).catch(() => setFaqs([]));
  }, []);

  return (
    <div data-testid="faq-page">
      <section className="bg-gradient-to-br from-[#084C3A] to-[#0B4F71] px-4 py-16 text-center sm:px-6">
        <h1 className="font-heading text-3xl font-bold text-white sm:text-4xl">Pertanyaan yang Sering Diajukan</h1>
        <p className="mt-3 text-white/80">Temukan jawaban seputar pendaftaran, program, dan layanan KBIHU Muhammadiyah Surabaya.</p>
      </section>
      <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6">
        {faqs === null ? (
          <LoadingScreen />
        ) : (
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((f, idx) => (
              <AccordionItem key={f.id} value={f.id} data-testid={`faq-page-item-${idx}`} className="rounded-2xl border border-slate-100 bg-white px-5 shadow-[0_2px_10px_rgba(15,107,79,0.04)]">
                <AccordionTrigger className="font-medium text-[#1F2937] hover:no-underline">{f.question}</AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-[#64748B]">{f.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        )}
      </div>
    </div>
  );
}
